export const getRatinga11yText = (rating: number, votes: number) => {
    const stars = Math.round(rating);

    return `betygsatt ${stars} av 5. ${votes} ${votes === 1 ? 'röst' : 'röster'}.`;
};
